<template>
  <div>
    {{ item.name }}
  </div>
</template>

<script>
export default {
  name: "CatalogItem",
  props: { item: Object },
}
</script>

<style scoped>

</style>